import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import type { ComponentProps } from 'react';

interface DetailItem {
  label: string;
  value: string | number;
}

interface MobileDetailItemsProps {
  items: DetailItem[];
  spacing?: number;
  sx?: ComponentProps<typeof Stack>['sx'];
}

export const MobileDetailItems = ({
  items,
  spacing = 0.5,
  sx,
}: MobileDetailItemsProps) => {
  return (
    <Stack spacing={spacing} sx={sx}>
      {items.map((item, idx) => (
        <Stack key={idx} direction="row" justifyContent="space-between">
          <Typography variant="body2" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {item.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
